import React, { useState, useRef } from "react";
import "./Home.css"
import Navbars from "../components/Navbar/Navbars";
import Carousel from "../components/Carousel/Carousel";
import Footer from "../components/Footer/Footer";
import { Link } from "react-router-dom";

function Home() {
  return (
    <>
      <div className="Appss">
        <Navbars />
        <Carousel/>

        {/* SERVICES SECTIONS */}
     <div class="work-body">
      <h2 class="work-do">What we do</h2>
     <section class="timeline">
      
      <div class="container-2 left-container">
      <i class="ri-plant-line" style={{color:"#ff8c00"}}></i>
      <Link to={"/service"} className="linkdec">
        <div class="text-box">
          <h2>Crop Production</h2>
         
          <p>It is our strong belief that crop production can provide millions of jobs for Southern Nigerian youths...</p>
        <span class="left-container-arrow"></span>
        </div></Link>
      </div>
 
      <div class="container-2 right-container">
      <i class="ri-bear-smile-line" style={{color:"#ff8c00"}}></i>
      <Link to={"/service"} className="linkdec">
        <div class="text-box">
          <h2>Animal Husbandry and Fish Farming</h2>
         
          <p>We strongly believe that youths can be engaged to mass produce meat for the country. To this effect...</p>
          <span class="right-container-arrow"></span>
        </div></Link>
      </div>
 
 
      <div class="container-2 left-container">
      <i class="ri-t-shirt-line" style={{color:"#ff8c00"}}></i>
      <Link to={"/service"} className="linkdec">
        <div class="text-box">
          <h2>Clothe Productions</h2>
       
          <p>Geega Resources is going to be engaging a segment of the youths in clothe productions. This, the organization will...</p>
          <span class="left-container-arrow"></span>
        </div></Link>
      </div>
 
      <div class="container-2 right-container">
      <i class="ri-creative-commons-line" style={{color:"#ff8c00"}}></i>
      <Link to={"/service"} className="linkdec">
        <div class="text-box">
          <h2>Shoe Production</h2>
         
          <p>Geega Resources is going to be importing the relevant machinery and materials used in shoe production and use them to engage youths in the Southern Nigeria in shoe...</p>
          <span class="right-container-arrow"></span>
        </div></Link>
      </div>
 
      <div class="container-2 left-container">
      <i class="ri-home-4-line" style={{color:"#ff8c00"}}></i>
      <Link to={"/service"} className="linkdec">
        <div class="text-box">
          <h2>Production of Wooden Furniture</h2>
       
          <p>Geega Resources is going to be importing chainsaw and other equipment, and materials used in wooden furniture production such as domestic and...</p>
          <span class="left-container-arrow"></span>
        </div></Link>
        
      </div>
      <div class="container-2 right-container">
      <i class="ri-cake-2-line" style={{color:"#ff8c00"}}></i>
      <Link to={"/service"} className="linkdec">
        <div class="text-box">
          <h2>Baking Bread and Similar Products</h2>
         
          <p>To further tackle the problem of food insecurity in Nigeria, Geega Resources is going to be importing various machinery and equipment used in baking of bread and similar...</p>
          <span class="right-container-arrow"></span>
        </div></Link>
        </div>

        <div class="container-2 left-container">
        <i class="ri-water-flash-line" style={{color:"#ff8c00"}}></i>
        <Link to={"/service"} className="linkdec">
        <div class="text-box">
          <h2>Table Water Production</h2>
       
          <p>A segment of the youths is going to be trained and engaged in sachet water and table water production. This is to ensure that there is sufficiency of supply of water across the regions...</p>
          <span class="left-container-arrow"></span>
        </div></Link>
        
      </div>
     </section>
    </div>
    <hr style={{height:"1px"}}/>
    <Footer/>
      </div>
    </>
  );
}

export default Home;
